import React from 'react';
import { useNavigate } from 'react-router-dom';

import './article-component.scss';

interface ArticleProps {
  article: {
    id: string;
    title: string;
    summary: string;
    content: string;
    author: {
      name: string;
      title: string;
      avatar: string;
    };
    category: string;
    readTime: string;
    publishDate: string;
    tags: string[];
    relatedArticles?: Array<{
      id: string;
      title: string;
      type: string;
      readTime: string;
      image: string;
    }>;
  };
  onBack?: () => void;
}

const ArticleComponent: React.FC<ArticleProps> = ({ article, onBack }) => {
  const navigate = useNavigate();

  const handleRelatedClick = (relatedId: string, type: string) => {
    if (type === 'Article') {
      navigate(`/wellness/articles/${relatedId}`);
    } else if (type === 'Video') {
      navigate(`/wellness/videos/${relatedId}`);
    }
    // Scroll to top when navigating to related content
    window.scrollTo(0, 0);
  };

  return (
    <div className="article-component">
      <div className="phone-frame">
        {/* Header */}
        {/* <div className="header">
          <button className="back-button" onClick={onBack}>←</button>
          <div className="header-actions">
            <button className="action-btn">🔖</button>
            <button className="action-btn">↗</button>
            <button className="action-btn">⋯</button>
          </div>
        </div> */}

        {/* Hero Image */}
        <div className="hero-image">📖</div>

        {/* Article Content */}
        <div className="article-content">
          {/* Meta Information */}
          <div className="article-meta">
            <span className="meta-badge">{article.category}</span>
            <span className="read-time">⏱ {article.readTime}</span>
            <span>•</span>
            <span>{article.publishDate}</span>
          </div>

          {/* Title */}
          <h1 className="article-title">{article.title}</h1>

          {/* Summary */}
          <div className="article-summary">
            {article.summary}
          </div>

          {/* Author Info */}
          <div className="author-info">
            <div className="author-avatar">{article.author.avatar}</div>
            <div className="author-details">
              <div className="author-name">{article.author.name}</div>
              <div className="author-title">{article.author.title}</div>
            </div>
          </div>

          {/* Article Body */}
          <div className="article-body" dangerouslySetInnerHTML={{ __html: article.content }} />

          {/* Tags */}
          <div className="tags">
            {article.tags.map((tag, index) => (
              <span key={index} className="tag">{tag}</span>
            ))}
          </div>

          {/* Related Articles */}
          {article.relatedArticles && (
            <div className="related-section">
              <div className="screen-title">Related Articles</div>
              {article.relatedArticles.map((related, index) => (
                <div 
                  key={index} 
                  className="related-card"
                  onClick={() => handleRelatedClick(related.id, related.type)}
                >
                  <div className="related-image">{related.image}</div>
                  <div className="related-content">
                    <div className="related-title">{related.title}</div>
                    <div className="related-meta">
                      <span className="meta-badge">{related.type}</span>
                      <span>{related.readTime}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Floating Toolbar */}
        <div className="floating-toolbar">
          <button className="toolbar-btn">❤️</button>
          <button className="toolbar-btn">🔖</button>
          <button className="toolbar-btn">💬</button>
          <button className="toolbar-btn">↗</button>
        </div>
      </div>
    </div>
  );
};

export default ArticleComponent;
